module.exports = __webpack_public_path__ + "img/material-background.7e14180f.jpg";